import api from '@/api'

const {$student, $pricing, $academic} = api;

export const {$examenes} = $student;
export const { $types } = $pricing;

export const { $setting } = $academic